import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getFees } from "../../network/api/ShippingFees.js";
import PopUp from "../room/PopUp.jsx";
import { applying } from "../../network/api/coupon.js";
import axios from "axios";
import { link } from "../../config.js";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

function OrderSummary(props) {
  const [code, setCode] = useState("");
  const [ProductItems, setProductItems] = useState([]);
  const [message, setMessage] = useState("");
  const [successmessage, setsuccessMessage] = useState("");
  const navigate = useNavigate();
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const savedCode = localStorage.getItem("couponCode");
    const savedDiscount = parseFloat(
      localStorage.getItem("discountPercentage")
    );
    if (savedCode) setCode(savedCode);
    if (!isNaN(savedDiscount)) setDiscountPercentage(savedDiscount);
  }, []);

  const applyCoupon = async (e) => {
    e.preventDefault();
    //  const response= await applying(code);
    //  if(response.status===200){
    //   setDiscountPercentage(response.data.discount);
    //   setsuccessMessage('Coupon applied successfully');
    //   localStorage.setItem('couponCode', code);
    //   localStorage.setItem('discountPercentage', response.data.discount);
    setCode("");
    //   setTimeout(() => {
    //     setsuccessMessage("");
    //   }, 2000);
    //  }else{
    //   setMessage(response?.data?.message);
    //   setTimeout(() => {
    //     setMessage("");
    //   }, 2000);

    //  }

    try {
      const response = await axios.get(`${link}/coupons/show/code/${code}`, {
        headers: {
          Authorization: Cookies.get("user"),
        },
      });
      props.setCoupon(response.data.coupon);

      if (response.status == 200) {
        setsuccessMessage("Coupon code applied successfully");
        setTimeout(() => {
          setsuccessMessage("");
        }, 2000);
      } else {
        setMessage("Coupon code is invalid");
        setTimeout(() => {
          setMessage("");
        }, 2000);
      }
    } catch (error) {
      setMessage("Coupon code is invalid");
    }
  };

  const handleCheckoutClick = () => {
    if (props.cartItems?.length > 0) {
      navigate("/checkout");
    } else {
      // Set a message when the cart is empty
      setMessage("Your cart is empty");
      // Clear the message after 2 seconds
      setTimeout(() => {
        setMessage("");
      }, 2000);
    }
  };
  
  
  const discountAmount = (props.totalPrice * discountPercentage) / 100;
  const finalPrice = props.finalPrice - discountAmount;

  
  return (
    <div className="order-summary d-flex flex-column align-self-lg-start position-relative ">
      <div>
        {message && (
          <div className="alert alert-danger text-center" role="alert">
            {message}
          </div>
        )}
        {successmessage && (
          <div className="alert alert-success text-center" role="alert">
            {successmessage}
          </div>
        )}
        <h3>
         {t("orderDetails")} <span></span>
        </h3>
        <form className="voucher-code">
          <input
            type="text"
            name="buy-sumbol"
            value={code}
            className=" flex-grow-1 "
            onChange={(e) => {
              setCode(e.target.value);
            }}
            placeholder={t("Enter Coupon Code")}
          />
          {/* <input type="submit"
            value="طبق"
            className="submit"
            
          /> */}
          <button className="submit" onClick={applyCoupon}>
          {t('submit')}
          </button>
        </form>
        <div className="amount-total d-flex justify-content-between">
          <div className="d-flex">
            <p>{t("Total Amount After Discount")}</p>
            <span>({props.totalQuantity} {t("Items")})</span>
          </div>
          <p>{t('curency')} {props.totalPrice.toFixed(2)}</p>
        </div>

        {/* <div className="amount-total d-flex justify-content-between">
          <div className="d-flex">
            <p>المبلغ الإجمالى</p>
            <span>({props.totalQuantity} قطع)</span>
          </div>
          <p>ج.م. {props.totalPrice}</p>
        </div>
        <div className="amount-total d-flex justify-content-between">
          <div className="d-flex">
            <p>المبلغ الإجمالى</p>
            <span>({props.totalQuantity} قطع)</span>
          </div>
          <p>ج.م. {props.totalPrice}</p>
        </div> */}

        <div className="amount-total d-flex justify-content-between">
          <div className="d-flex">
            <p>{t("VAT Value Added Tax")}</p>
          </div>
          <p>{t('curency')} {props.fees}</p>
        </div>
        <div className="amount-total d-flex justify-content-between">
          <div className="d-flex">
            <p>{t("Shipping Expenses")}</p>
          </div>
          <p>{t('curency')} {props.shippingExpenses}</p>
        </div>

        <div className="total d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <p className="ms-2">{t("total")}</p>
            <span>{t("Including VAT")}</span>
          </div>
          <p>{t('curency')} {finalPrice.toFixed(2)}</p>
        </div>
      </div>
      <div className="btn">
        <button onClick={handleCheckoutClick}>{t("Pay now")}</button>
      </div>
    </div>
  );
}
export default OrderSummary;
